import { SlugSchema } from "@aurumiq/cms-schema";
import { Input } from "@aurumiq/ui/components/input";
import { Label } from "@aurumiq/ui/components/label";
import { useId } from "react";
import { SchemaForm } from "../schema-form/schema-form";
import { META_FIELDS } from "./blocks";

export function SeoPanel({
  title,
  slug,
  meta,
  onTitle,
  onSlug,
  onMeta,
  metaIssues,
}: {
  title: string;
  slug: string;
  meta: Record<string, unknown>;
  onTitle: (t: string) => void;
  onSlug: (s: string) => void;
  onMeta: (m: Record<string, unknown>) => void;
  metaIssues?: readonly { path: PropertyKey[]; message: string }[];
}) {
  const id = useId();
  const slugOk = SlugSchema.safeParse(slug);
  return (
    <div className="grid gap-4">
      <h2 className="font-semibold">Page &amp; SEO</h2>
      <div>
        <Label htmlFor={`${id}-title`}>Title</Label>
        <Input
          id={`${id}-title`}
          value={title}
          maxLength={160}
          onChange={(e) => onTitle(e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor={`${id}-slug`}>Slug</Label>
        <Input
          id={`${id}-slug`}
          value={slug}
          className="font-mono"
          aria-invalid={slugOk.success ? undefined : true}
          onChange={(e) => onSlug(e.target.value)}
        />
        {!slugOk.success ? (
          <p className="mt-1 text-destructive text-xs">{slugOk.error.issues[0]?.message}</p>
        ) : (
          <p className="mt-1 text-muted-foreground text-xs">
            Changing the slug changes the public URL.
          </p>
        )}
      </div>
      <SchemaForm
        fields={META_FIELDS}
        value={meta}
        onChange={onMeta}
        issues={metaIssues}
        omit={["post"]}
      />
    </div>
  );
}
